import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useAuth } from '@/lib/auth-context'

export const Route = createFileRoute('/')({
  component: IndexPage,
})

function IndexPage() {
  const { user, loading, isPlatformAdmin } = useAuth()

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" />
  }

  if (!isPlatformAdmin) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-destructive">Zugriff verweigert</h1>
          <p className="text-muted-foreground mt-2">
            Du hast keine Berechtigung, auf das Admin-Panel zuzugreifen.
          </p>
        </div>
      </div>
    )
  }

  return <Navigate to="/dashboard" />
}
